import React from "react";

// Shim for Vercel Analytics when running outside of Next.js.
// It intentionally renders nothing so the CRA build stays valid.
// This shim also forwards console messages to a lightweight serverless
// endpoint at `/api/log` so they appear in Vercel deployment logs.
// Remove or disable forwarding in production if you don't want client logs collected.
function forwardLog(level, args) {
  try {
    if (typeof window === "undefined") return;
    // Fire-and-forget; don't await to avoid slowing app startup
    fetch("/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ level, args, url: window.location.href, ts: Date.now() }),
    }).catch(() => {});
  } catch (e) {}
}

if (typeof window !== "undefined") {
  ["log", "info", "warn", "error", "debug"].forEach((method) => {
    const orig = console[method]?.bind(console) ?? (() => {});
    console[method] = (...args) => {
      try {
        orig(...args);
      } catch (e) {}
      try {
        forwardLog(method, args.map((a) => {
          try { return typeof a === 'object' ? JSON.stringify(a) : String(a); } catch { return String(a); }
        }));
      } catch (e) {}
    };
  });
}

export function Analytics() {
  return null;
}

export default Analytics;
